<dx-scroll-view data-testid="modification-scroll-view">
  <form #formElement (submit)="onSubmit($event)">
    <dx-form
      #dxForm
      data-testid="form"
      id="form"
      class="cards-wide"
      [formData]="modificationData"
      [items]="formItems"
      [showValidationSummary]="true"
      [colCount]="formColCount"
      validationGroup="formGroup"
      (onContentReady)="onFormContentReady($event)"
      (onFieldDataChanged)="onFieldDataChanged($event)">

      <!-- Request Type - Static First Field -->
      <dxi-item
        [colSpan]="formColCount"
        labelMode="static"
        dataField="requestType"
        editorType="dxSelectBox"
        cssClass="dx-widget"
        [editorOptions]="{
          items: requestTypes,
          valueExpr: 'name',
          displayExpr: 'name',
          required: true,
          searchMode: 'contains',
          searchEnabled: true,
          onSelectionChanged: onRequestTypeSelectionChanged,
          onOpened: onRequestTypeDropdownOpened,
          disabled: isEditable
        }">
        <dxo-label text="Request Type"></dxo-label>
        <dxi-validation-rule
          type="required"
          message="Request Type is required">
        </dxi-validation-rule>
      </dxi-item>

      <div *dxTemplate="let formItemData of 'loanAmountsGridTemplate'">
        <app-loan-amounts-grid
          [loanAmounts]="modificationData.loanNumbers"
          [loanData]="allLoanNumbers"
          [showInactiveLoans]="showInactiveLoans"
          [showAmountColumn]="false"
          [shouldDisableCheckbox]="shouldDisableCheckbox"
          [activeLoanCheckboxText]="activeLoanCheckboxText"
          [isGridInEditMode]="isGridInEditMode"
          [loanItemTemplate]="loanItemTemplate"
          (showInactiveLoansChange)="onGridShowInactiveLoansChange($event)"
          (gridEditModeChange)="onGridEditModeChange($event)"
          (loanAmountsChange)="onGridLoanAmountsChange($event)">
        </app-loan-amounts-grid>
      </div>

      <!-- File Upload Template -->
      <div *dxTemplate="let section of 'fileUploadTemplate'">
        <app-file-upload
          labelText=""
          selectButtonText="Browse or drop files here"
          [existingFileUrls]="isEditable ? (task?.parentUrls ?? []) : []"
          (onFileUploadEventEmitter)="onFileUpload($event)"
          (onFileRemoveEventEmitter)="onFileRemove($event)"/>
      </div>
    </dx-form>

    <dx-load-panel
      data-testid="modification-load-panel"
      container=".cards-wide"
      [position]="{ of: '.content' }"
      [visible]="isLoading"
      [showPane]="true">
    </dx-load-panel>
  </form>
</dx-scroll-view>
